/**
 * 任务执行状态
 */
export var TaskStatus;
(function (TaskStatus) {
    /** 无效状态 - 节点未初始化或已被重置 */
    TaskStatus[TaskStatus["Invalid"] = 0] = "Invalid";
    /** 成功 - 节点执行成功完成 */
    TaskStatus[TaskStatus["Success"] = 1] = "Success";
    /** 失败 - 节点执行失败 */
    TaskStatus[TaskStatus["Failure"] = 2] = "Failure";
    /** 运行中 - 节点正在执行，需要在后续帧继续 */
    TaskStatus[TaskStatus["Running"] = 3] = "Running";
})(TaskStatus || (TaskStatus = {}));
/**
 * 内置节点类型常量
 */
export const NodeType = {
    /** 复合节点 - 有多个子节点 */
    Composite: 'composite',
    /** 装饰器节点 - 有一个子节点 */
    Decorator: 'decorator',
    /** 动作节点 - 叶子节点 */
    Action: 'action',
    /** 条件节点 - 叶子节点 */
    Condition: 'condition'
};
/**
 * 复合节点类型
 */
export var CompositeType;
(function (CompositeType) {
    /** 序列 - 按顺序执行，全部成功才成功 */
    CompositeType["Sequence"] = "sequence";
    /** 选择 - 按顺序执行，任一成功则成功 */
    CompositeType["Selector"] = "selector";
    /** 并行 - 同时执行所有子节点 */
    CompositeType["Parallel"] = "parallel";
    /** 并行选择 - 并行执行，任一成功则成功 */
    CompositeType["ParallelSelector"] = "parallel-selector";
    /** 随机序列 - 随机顺序执行序列 */
    CompositeType["RandomSequence"] = "random-sequence";
    /** 随机选择 - 随机顺序执行选择 */
    CompositeType["RandomSelector"] = "random-selector";
})(CompositeType || (CompositeType = {}));
/**
 * 装饰器节点类型
 */
export var DecoratorType;
(function (DecoratorType) {
    /** 反转 - 反转子节点结果 */
    DecoratorType["Inverter"] = "inverter";
    /** 重复 - 重复执行子节点 */
    DecoratorType["Repeater"] = "repeater";
    /** 直到成功 - 重复直到成功 */
    DecoratorType["UntilSuccess"] = "until-success";
    /** 直到失败 - 重复直到失败 */
    DecoratorType["UntilFail"] = "until-fail";
    /** 总是成功 - 无论子节点结果都返回成功 */
    DecoratorType["AlwaysSucceed"] = "always-succeed";
    /** 总是失败 - 无论子节点结果都返回失败 */
    DecoratorType["AlwaysFail"] = "always-fail";
    /** 条件装饰器 - 基于条件执行子节点 */
    DecoratorType["Conditional"] = "conditional";
    /** 冷却 - 冷却时间内阻止执行 */
    DecoratorType["Cooldown"] = "cooldown";
    /** 超时 - 超时则返回失败 */
    DecoratorType["Timeout"] = "timeout";
})(DecoratorType || (DecoratorType = {}));
/**
 * 中止类型
 *
 * 用于动态优先级和条件重新评估
 */
export var AbortType;
(function (AbortType) {
    /** 无 - 不中止任何节点 */
    AbortType["None"] = "none";
    /** 自身 - 条件变化时可以中止自身的执行 */
    AbortType["Self"] = "self";
    /** 低优先级 - 条件满足时可以中止低优先级的兄弟节点 */
    AbortType["LowerPriority"] = "lower-priority";
    /** 两者 - 可以中止自身和低优先级节点 */
    AbortType["Both"] = "both";
})(AbortType || (AbortType = {}));
/**
 * 黑板变量类型
 */
export var BlackboardValueType;
(function (BlackboardValueType) {
    BlackboardValueType["String"] = "string";
    BlackboardValueType["Number"] = "number";
    BlackboardValueType["Boolean"] = "boolean";
    BlackboardValueType["Vector2"] = "vector2";
    BlackboardValueType["Vector3"] = "vector3";
    BlackboardValueType["Object"] = "object";
    BlackboardValueType["Array"] = "array";
})(BlackboardValueType || (BlackboardValueType = {}));
//# sourceMappingURL=TaskStatus.js.map